/**
 * QuizButtons Component
 * Navigation and submission buttons for quiz flow
 */

import React from 'react';
import { Box, Button, CircularProgress } from '@mui/material';

interface QuizButtonsProps {
  isFirstQuestion: boolean;
  isLastQuestion: boolean;
  isLoading: boolean;
  onPrevious: () => void;
  onNext: () => void;
  onSubmit: () => void;
  disableNext?: boolean;
  disableSubmit?: boolean;
  submitButtonText?: string | null;
}

function QuizButtons({
  isFirstQuestion,
  isLastQuestion,
  isLoading,
  onPrevious,
  onNext,
  onSubmit,
  disableNext = false,
  disableSubmit = false,
  submitButtonText,
}: QuizButtonsProps): JSX.Element {
  return (
    <Box className="cla-quiz-navigation" sx={{ display: 'flex', gap: 2, justifyContent: 'space-between', mt: 4 }}>
      <Button
      className="cla-quiz-button cla-quiz-button-previous"
        variant="outlined"
        onClick={onPrevious}
        disabled={isFirstQuestion || isLoading}
      >
        Previous
      </Button>

      <Box sx={{ display: 'flex', gap: 2 }}>
        {isLastQuestion ? (
          <Button
            className="cla-quiz-button cla-quiz-button-submit"
            variant="contained"
            color="primary"
            onClick={() => {
              // eslint-disable-next-line no-console
              console.warn('[CIJ] Final quiz button clicked');
              onSubmit();
            }}
            disabled={isLoading || disableSubmit}
            sx={{ minWidth: 120 }}
          >
            {isLoading ? (
              <>
                <CircularProgress size={20} sx={{ mr: 1 }} />
                Submitting...
              </>
            ) : (
              submitButtonText?.trim() || 'Submit Quiz'
            )}
          </Button>
        ) : (
          <Button
            className="cla-quiz-button cla-quiz-button-next"
            variant="contained"
            color="primary"
            onClick={onNext}
            disabled={isLoading || disableNext}
          >
            Next
          </Button>
        )}
      </Box>
    </Box>
  );
}

export default QuizButtons;
